import { render, staticRenderFns } from "./subSkills.vue?vue&type=template&id=63f2bc2f&scoped=true"
import script from "./subSkills.vue?vue&type=script&lang=js"
export * from "./subSkills.vue?vue&type=script&lang=js"
import style0 from "./subSkills.vue?vue&type=style&index=0&id=63f2bc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2bc2f",
  null
  
)

export default component.exports